<template>
  <div class="service-hall">
    <section class="service-hall-hero" aria-label="学会服务">
      <img
        class="service-hall-hero__img"
        :src="heroSrc"
        alt="地球生命演化示意图"
      >
    </section>

    <section class="service-hall-cards" aria-label="核心服务入口">
      <article
        v-for="item in hallCards"
        :key="item.tab"
        class="service-hall-card-item"
      >
        <span class="service-hall-card-item__icon" aria-hidden="true" v-html="item.icon" />
        <h3>{{ item.title }}</h3>
        <p>{{ item.desc }}</p>
        <button type="button" class="service-hall-card-item__link" @click="front.goServicesTab(item.tab)">
          {{ item.action }} <span aria-hidden="true">→</span>
        </button>
      </article>
    </section>
  </div>
</template>

<script>
const ICONS = {
  branches: '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 10v4h3l5 4V6L7 10H4Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M16 9.5a3.5 3.5 0 0 1 0 5M18.5 7.5a6.5 6.5 0 0 1 0 9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
  member: '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="5" width="18" height="13" rx="1.5" stroke="currentColor" stroke-width="1.6"/><path d="M8 21h8M12 18v3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
  conference: '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" stroke-width="1.6"/><path d="M3 10h18M8 3v4M16 3v4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>'
}

export default {
  name: 'ServiceHallCard',
  inject: ['front'],
  computed: {
    heroSrc() {
      return `${process.env.BASE_URL}assets/service-hall-hero.jpg?v=20260902e`
    }
  },
  data() {
    return {
      hallCards: [
        {
          tab: 'branches',
          title: '专业分会',
          desc: '学会下设 11 个专业分会，覆盖古生物学主要研究方向，可按兴趣绑定关注。',
          action: '了解分会',
          icon: ICONS.branches
        },
        {
          tab: 'member',
          title: '会员服务',
          desc: '在线申请入会、缴纳会费、绑定专业分会。享受正式会员专属权益与学术会议优惠。',
          action: '申请入会',
          icon: ICONS.member
        },
        {
          tab: 'conference',
          title: '学术会议',
          desc: '浏览各分会发布的学术会议，在线报名、缴纳注册费、上传摘要并填写参会信息。',
          action: '浏览会议',
          icon: ICONS.conference
        }
      ]
    }
  }
}
</script>
